
import { useTheme } from '@emotion/react';
import { ThemeProvider } from '@mui/system';
import { createTheme } from '@mui/material/styles';

function TableTheme({ children }) {
    const theme = useTheme();

    const newTheme = (theme) => createTheme({
        ...theme,
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: theme.typography.subtitle2.fontSize
                    }
                }
            }
        }
    })

    return (
        < ThemeProvider theme={newTheme} >
            {children}
        </ThemeProvider>
    );
}

export default TableTheme;
